/* eslint-disable */
/**
 * 설날, 추석 계산 http://www.joshi.co.kr/index.php?document_srl=594&mid=board_XbwP90
 */
export default class Holidays {
    getDates(nYear) {
        this.year = nYear;

        const aHolidays = this._aHoliday.slice();
        const aLunarHolidays = [{ sName: '설날전날', nMonth: 12, nDay: this._setLunarNewYearHoliday(nYear), bIsLunar: false, bShowName: false },
            { sName: '설날', nMonth: 1, nDay: 1, bIsLunar: false, bShowName: false },
            { sName: '설날다음날', nMonth: 1, nDay: 2, bIsLunar: false, bShowName: false },
            { sName: '석가탄신일', nMonth: 4, nDay: 8, bIsLunar: false, bShowName: true },
            { sName: '추석전날', nMonth: 8, nDay: 14, bIsLunar: false, bShowName: false },
            { sName: '추석', nMonth: 8, nDay: 15, bIsLunar: false, bShowName: true },
            { sName: '추석다음날', nMonth: 8, nDay: 16, bIsLunar: false, bShowName: false },
        ];

        aLunarHolidays.map(item => {
            if (item.sName === '설날전날') {
                return aHolidays.push(Object.assign({ sName: item.sName }, this._lunarCalc(nYear - 1, item.nMonth, item.nDay, 2, 0)));
            }

            return aHolidays.push(Object.assign({ sName: item.sName }, this._lunarCalc(nYear, item.nMonth, item.nDay, 2, 0)));
        });

        return aHolidays;
    }

    _aLunarMonthTable = [
        [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2],
        [2, 1, 2, 5, 2, 1, 2, 1, 2, 1, 2, 1],
        [1, 2, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2], /* 1801 */
        [1, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2, 1],
        [2, 3, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 1, 3, 2, 1, 2, 2, 2, 1],
        [2, 2, 1, 2, 1, 1, 1, 2, 1, 2, 2, 1],
        [2, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [1, 2, 2, 1, 5, 2, 1, 2, 1, 1, 2, 1],
        [2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1, 2],
        [1, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1, 2],
        [1, 1, 5, 2, 1, 2, 2, 1, 2, 2, 1, 2], /* 1811 */
        [1, 1, 2, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 1, 1, 1, 2, 1, 2, 2, 2, 1],
        [2, 5, 2, 1, 1, 1, 2, 1, 2, 2, 1, 2],
        [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 5, 1, 2, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1],
        [2, 1, 2, 2, 1, 2, 2, 1, 2, 1, 1, 2],
        [1, 2, 1, 5, 2, 2, 1, 2, 2, 1, 2, 1],
        [1, 2, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2], /* 1821 */
        [2, 1, 5, 1, 1, 2, 1, 2, 2, 1, 2, 2],
        [2, 1, 2, 1, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 4, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 1, 2, 2, 4, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 1, 2, 3, 2, 1, 2, 2, 1, 2, 2, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2], /* 1831 */
        [1, 2, 1, 2, 1, 1, 2, 1, 5, 2, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 5, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
        [1, 2, 1, 5, 1, 2, 2, 1, 2, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 4, 1, 1, 2, 1, 2, 1, 2, 2, 1],   /* 1841 */
        [2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 1],
        [2, 2, 2, 1, 2, 1, 4, 1, 2, 1, 2, 1],
        [2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 5, 2, 1, 2, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 3, 2, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 1, 2, 3, 2, 1, 2, 2],   /* 1851 */
        [2, 1, 2, 2, 1, 1, 2, 1, 2, 1, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 5, 2, 1, 2, 1, 2],
        [1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
        [1, 2, 1, 1, 5, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [2, 1, 6, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2],   /* 1861 */
        [2, 1, 2, 1, 2, 2, 1, 5, 2, 1, 1, 2],
        [1, 2, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
        [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 4, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],
        [1, 2, 2, 3, 2, 1, 1, 2, 1, 2, 2, 1],
        [2, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 2, 2, 1, 2, 1, 2, 1, 1, 5, 2, 1],
        [2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1, 2],   /* 1871 */
        [1, 2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2],
        [1, 1, 2, 1, 2, 4, 2, 1, 2, 2, 1, 2],
        [1, 1, 2, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1],
        [2, 2, 1, 1, 5, 1, 2, 1, 2, 2, 1, 2],
        [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 2, 4, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 1, 2, 2, 1, 2, 2, 1, 2, 1, 1, 2],
        [1, 2, 1, 2, 1, 2, 5, 2, 2, 1, 2, 1],   /* 1881 */
        [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2],
        [2, 1, 1, 2, 3, 2, 1, 2, 2, 1, 2, 2],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 2, 1, 5, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 5, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],   /* 1891 */
        [1, 1, 2, 1, 1, 5, 2, 2, 1, 2, 2, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 5, 1, 2, 1, 2, 1, 2, 1],
        [2, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 5, 2, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 5, 2, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],   /* 1901 */
        [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1],
        [2, 2, 1, 2, 2, 1, 1, 2, 1, 2, 1, 2],
        [1, 2, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 1, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2],
        [1, 5, 1, 2, 1, 2, 1, 2, 2, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 1, 1, 5, 1, 2, 2, 1, 2, 2],   /* 1911 */
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
        [2, 2, 1, 2, 5, 1, 2, 1, 2, 1, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 3, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 2, 1, 1, 2, 1, 5, 2, 1, 2, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],   /* 1921 */
        [2, 1, 2, 2, 3, 2, 1, 1, 2, 1, 2, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
        [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1],
        [2, 1, 2, 5, 2, 1, 2, 2, 1, 2, 1, 2],
        [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 5, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],
        [1, 2, 2, 1, 1, 5, 1, 2, 1, 2, 2, 1],
        [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],   /* 1931 */
        [2, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
        [1, 2, 2, 1, 6, 1, 2, 1, 2, 1, 1, 2],
        [1, 2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2],
        [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 4, 1, 1, 2, 2, 1, 2, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1],
        [2, 2, 1, 1, 2, 1, 4, 1, 2, 2, 1, 2],
        [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 2, 1, 2, 2, 4, 1, 1, 2, 1, 2, 1],   /* 1941 */
        [2, 1, 2, 2, 1, 2, 2, 1, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 4, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2],
        [2, 5, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 3, 2, 1, 2, 1, 2],
        [1, 2, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],   /* 1951 */
        [1, 2, 1, 2, 4, 1, 2, 2, 1, 2, 1, 2],
        [1, 2, 1, 1, 2, 2, 1, 2, 2, 1, 2, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2],
        [2, 1, 4, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 1, 5, 2, 1, 2, 2],
        [1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 5, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],   /* 1961 */
        [1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 2, 3, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 2],
        [1, 2, 5, 2, 1, 1, 2, 1, 1, 2, 2, 1],
        [2, 2, 1, 2, 2, 1, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 2, 1, 5, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],
        [1, 2, 1, 1, 5, 2, 1, 2, 2, 2, 1, 2],   /* 1971 */
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 5, 1, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 2, 1, 5, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 1],
        [2, 1, 2, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 6, 1, 2, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],   /* 1981 */
        [2, 1, 2, 3, 2, 1, 1, 2, 1, 2, 2, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [2, 1, 2, 2, 1, 1, 2, 1, 1, 5, 2, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 1],
        [2, 1, 2, 1, 2, 5, 2, 2, 1, 2, 1, 2],
        [1, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 1, 5, 1, 2, 2, 1, 2, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],   /* 1991 */
        [1, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [1, 2, 5, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 1, 2, 5, 2, 1, 1, 2],
        [1, 2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 3, 2, 2, 1, 2, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1],
        [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1],
        [2, 2, 1, 5, 2, 1, 1, 2, 1, 2, 1, 2],   /* 2001 */
        [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2],
        [1, 5, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 1, 5, 2, 2, 1, 2, 2],
        [1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2],
        [2, 2, 1, 1, 5, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],   /* 2011 */
        [2, 1, 2, 5, 2, 2, 1, 1, 2, 1, 2, 1],
        [2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 2, 2, 1, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 2, 1, 2, 1, 4, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2],
        [2, 1, 2, 5, 2, 1, 1, 2, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],   /* 2021 */
        [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
        [1, 5, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 2, 1, 1, 5, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1],
        [2, 2, 2, 1, 5, 1, 2, 1, 1, 2, 2, 1],
        [2, 2, 1, 2, 2, 1, 1, 2, 1, 1, 2, 2],
        [1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 5, 2, 1, 2, 2, 1, 2, 1, 2, 1],   /* 2031 */
        [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 5, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 1, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 4, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1],
        [2, 2, 1, 2, 5, 2, 1, 2, 1, 2, 1, 1],
        [2, 1, 2, 2, 1, 2, 1, 2, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],   /* 2041 */
        [1, 5, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2],
        [2, 1, 2, 1, 1, 2, 3, 2, 1, 2, 2, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
        [2, 1, 2, 2, 4, 1, 2, 1, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 2, 1, 2, 1, 1, 2, 1],
        [2, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2, 1],
        [1, 2, 4, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 2],   /* 2051 */
        [1, 2, 1, 1, 2, 1, 1, 5, 2, 2, 2, 2],
        [1, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2],
        [1, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2],
        [1, 2, 2, 1, 2, 4, 1, 1, 2, 1, 2, 1],
        [2, 2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2],
        [1, 2, 2, 1, 2, 1, 2, 2, 1, 1, 2, 1],
        [2, 1, 2, 4, 2, 1, 2, 1, 2, 2, 1, 1],
        [2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 1, 2, 1, 1, 2, 2, 1, 2, 2, 1],
        [2, 2, 3, 2, 1, 1, 2, 1, 2, 2, 2, 1],   /* 2061 */
        [2, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1],
        [2, 2, 1, 2, 1, 2, 3, 2, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2],
        [1, 2, 1, 2, 5, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 1, 2, 2, 1, 2, 2, 1, 2],
        [1, 2, 1, 5, 1, 2, 1, 2, 2, 2, 1, 2],
        [2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2],
        [2, 1, 2, 1, 2, 1, 1, 5, 2, 1, 2, 2],   /* 2071 */
        [2, 1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2],
        [2, 1, 2, 2, 1, 2, 1, 1, 2, 1, 2, 1],
        [2, 1, 2, 2, 1, 5, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 2, 1, 2, 1, 2, 2, 1, 2, 1],
        [2, 1, 2, 3, 2, 1, 2, 2, 2, 1, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2],
        [1, 2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [2, 1, 5, 2, 1, 1, 2, 1, 2, 1, 2, 2],
        [1, 2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2],   /* 2081 */
        [1, 2, 2, 2, 1, 2, 3, 2, 1, 1, 2, 2],
        [1, 2, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1],
        [2, 1, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2],
        [1, 2, 1, 1, 6, 1, 2, 2, 1, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1],
        [2, 1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2],
        [1, 2, 1, 5, 1, 2, 1, 1, 2, 2, 2, 1],
        [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1],
        [2, 2, 2, 1, 2, 1, 1, 5, 1, 2, 2, 1],
        [2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1],   /* 2091 */
        [2, 2, 1, 2, 2, 1, 2, 1, 2, 1, 2, 1],
        [1, 2, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1],
        [2, 1, 1, 2, 1, 2, 2, 1, 2, 2, 1, 2],
        [1, 2, 1, 1, 2, 1, 2, 1, 2, 2, 2, 1],
        [2, 1, 2, 3, 2, 1, 1, 2, 2, 2, 1, 2],
        [2, 1, 2, 1, 1, 2, 1, 1, 2, 2, 1, 2],
        [2, 2, 1, 2, 1, 1, 2, 1, 1, 2, 1, 2],
        [2, 5, 2, 2, 1, 1, 2, 1, 1, 2, 1, 2],
        [2, 2, 1, 2, 1, 2, 1, 2, 1, 1, 2, 1],
        [2, 2, 1, 2, 2, 1, 5, 2, 1, 1, 2, 1]
    ]

    // 양력 기준 공휴일
    _aHoliday = [
        { sName: '신정', nMonth: 1, nDay: 1, bIsLunar: false, bShowName: true },

        // {sName : "설날전날", nMonth : 12, nDay : 0, bIsLunar : true, bShowName : false},
        // {sName : "설날전날", nMonth : 12, nDay : 0, bIsLunar : true, bShowName : false},
        // {sName : '설날다음날', nMonth : 1, nDay : 2, bIsLunar : true, bShowName : false},

        { sName: '3·1절', nMonth: 3, nDay: 1, bIsLunar: false, bShowName: true },
        // {sName : "석가탄신일", nMonth : 4, nDay : 8, bIsLunar : true, bShowName : true},
        { sName: '어린이날', nMonth: 5, nDay: 5, bIsLunar: false, bShowName: true },
        { sName: '현충일', nMonth: 6, nDay: 6, bIsLunar: false, bShowName: true },
        { sName: '광복절', nMonth: 8, nDay: 15, bIsLunar: false, bShowName: true },

        // {sName : "추석전날", nMonth : 8, nDay : 14, bIsLunar : true, bShowName : false},
        // {sName : "추석", nMonth : 8, nDay : 15, bIsLunar : true, bShowName : true},
        // {sName : "추석다음날", nMonth : 8, nDay : 16, bIsLunar : true, bShowName : false},

        { sName: '개천절', nMonth: 10, nDay: 3, bIsLunar: false, bShowName: true },
        { sName: '한글날', nMonth: 10, nDay: 9, bIsLunar: false, bShowName: true },
        { sName: '성탄절', nMonth: 12, nDay: 25, bIsLunar: false, bShowName: true }
    ]

    _getLunarMonth = (nYear, nMonth) => this._aLunarMonthTable[nYear - 1 - 1799][nMonth - 1]

    /**
     * 설날 전날 날짜 셋팅
     * @private
     */
    _setLunarNewYearHoliday(nYear) {
        let nDay = 0;
        /* set the nDay before 설날 */
        if (this._getLunarMonth(nYear, 12) === 1) {
            nDay = 29;
        } else if (this._getLunarMonth(nYear, 12) === 2) {
            nDay = 30;
        }

        return nDay;
    }


     /* 양력 <-> 음력 변환 함수
     * nType : 1 - 양력 -> 음력
     *        2 - 음력 -> 양력
     * nLeapmonth : 0 - 평달
     *             1 - 윤달 (nType = 2 일때만 유효)
     */
    _lunarCalc(nYear, nMonth, nDay, nType, nLeapmonth) {
        let nSolYear;
        let nSolMonth;
        let nSolDay;
        let nLunYear;
        let nLunMonth;
        let nLunDay;
        let nLunLeapMonth;
        let nLunMonthDay;
        let nLunIndex;

        const aSolMonthDay = [31, 0, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        /* range check */
        if (nYear < 1800 || nYear > 2101) {
            console.log('1800년부터 2101년까지만 지원합니다');
            return null;
        }

        /* 속도 개선을 위해 기준 일자를 여러개로 한다 */
        if (nYear >= 2080) {
            /* 기준일자 양력 2080년 1월 1일 (음력 2079년 12월 10일) */
            nSolYear = 2080;
            nSolMonth = 1;
            nSolDay = 1;
            nLunYear = 2079;
            nLunMonth = 12;
            nLunDay = 10;
            nLunLeapMonth = 0;

            aSolMonthDay[1] = 29; /* 2080 년 2월 28일 */
            nLunMonthDay = 30; /* 2079년 12월 */
        } else if (nYear >= 2060) {
            /* 기준일자 양력 2060년 1월 1일 (음력 2059년 11월 28일) */
            nSolYear = 2060;
            nSolMonth = 1;
            nSolDay = 1;
            nLunYear = 2059;
            nLunMonth = 11;
            nLunDay = 28;
            nLunLeapMonth = 0;

            aSolMonthDay[1] = 29; /* 2060 년 2월 28일 */
            nLunMonthDay = 30; /* 2059년 11월 */
        } else if (nYear >= 2040) {
            /* 기준일자 양력 2040년 1월 1일 (음력 2039년 11월 17일) */
            nSolYear = 2040;
            nSolMonth = 1;
            nSolDay = 1;
            nLunYear = 2039;
            nLunMonth = 11;
            nLunDay = 17;
            nLunLeapMonth = 0;

            aSolMonthDay[1] = 29; /* 2040 년 2월 28일 */
            nLunMonthDay = 29; /* 2039년 11월 */
        } else if (nYear >= 2020) {
            /* 기준일자 양력 2020년 1월 1일 (음력 2019년 12월 7일) */
            nSolYear = 2020;
            nSolMonth = 1;
            nSolDay = 1;
            nLunYear = 2019;
            nLunMonth = 12;
            nLunDay = 7;
            nLunLeapMonth = 0;

            aSolMonthDay[1] = 29; /* 2020 년 2월 28일 */
            nLunMonthDay = 30; /* 2019년 12월 */
        } else if (nYear >= 2000) {
            /* 기준일자 양력 2000년 1월 1일 (음력 1999년 11월 25일) */
            nSolYear = 2000;
            nSolMonth = 1;
            nSolDay = 1;
            nLunYear = 1999;
            nLunMonth = 11;
            nLunDay = 25;
            nLunLeapMonth = 0;

            aSolMonthDay[1] = 29; /* 2000 년 2월 28일 */
            nLunMonthDay = 30; /* 1999년 11월 */
        }

        nLunIndex = nLunYear - 1799;

        while (true) {
            // console.log('nType', nType, 'nYear', nYear, 'nLunYear', nLunYear, 'nMonth', nMonth, 'nLunMonth', nLunMonth, 'nDay', nDay, 'nLunDay', nLunDay, 'nLeapmonth', nLeapmonth, 'nLunLeapMonth', nLunLeapMonth);
            if (nType === 1 && nYear === nSolYear && nMonth === nSolMonth && nDay === nSolDay) { // 양력 => 음력 변환
                return { nMonth: nLunMonth, nDay: nLunDay, nYear: nLunYear, nLeapMonth: nLunLeapMonth };
            } else if (nType === 2 && nYear === nLunYear && nMonth === nLunMonth && nDay === nLunDay && nLeapmonth === nLunLeapMonth) { // 음력 => 양력 변환
                return { nYear: nSolYear, nMonth: nSolMonth, nDay: nSolDay, nLeapMonth: 0 };
            }

            /* add a nDay of solar calendar */
            if (nSolMonth === 12 && nSolDay === 31) {
                nSolYear += 1;
                nSolMonth = 1;
                nSolDay = 1;

                /* set monthDay of Feb */
                if (nSolYear % 400 === 0) {
                    aSolMonthDay[1] = 29;
                } else if (nSolYear % 100 === 0) {
                    aSolMonthDay[1] = 28;
                } else if (nSolYear % 4 === 0) {
                    aSolMonthDay[1] = 29;
                } else {
                    aSolMonthDay[1] = 28;
                }
            } else if (aSolMonthDay[nSolMonth - 1] === nSolDay) {
                nSolMonth += 1;
                nSolDay = 1;
            } else {
                nSolDay += 1;
            }

            /* add a day of lunar calendar */
            if (nLunMonth === 12 &&
                ((this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 1 && nLunDay === 29) ||
                (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 2 && nLunDay === 30))) {
                nLunYear += 1;
                nLunMonth = 1;
                nLunDay = 1;

                if (nLunYear > 2101) {
                    console.log('입력하신 날 또는 달은 없습니다. 다시 입력하시기 바랍니다.');
                    break;
                }

                nLunIndex = nLunYear - 1799;

                if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 1) {
                    nLunMonthDay = 29;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 2) {
                    nLunMonthDay = 30;
                }
            } else if (nLunDay === nLunMonthDay) {
                if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] >= 3 && nLunLeapMonth === 0) {
                    nLunDay = 1;
                    nLunLeapMonth = 1;
                } else {
                    nLunMonth += 1;
                    nLunDay = 1;
                    nLunLeapMonth = 0;
                }

                if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 1) {
                    nLunMonthDay = 29;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 2) {
                    nLunMonthDay = 30;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 3) {
                    nLunMonthDay = 29;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 4 && nLunLeapMonth === 0) {
                    nLunMonthDay = 29;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 4 && nLunLeapMonth === 1) {
                    nLunMonthDay = 30;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 5 && nLunLeapMonth === 0) {
                    nLunMonthDay = 30;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 5 && nLunLeapMonth === 1) {
                    nLunMonthDay = 29;
                } else if (this._aLunarMonthTable[nLunIndex][nLunMonth - 1] === 6) {
                    nLunMonthDay = 30;
                }
            } else {
                nLunDay += 1;
            }
        }
        return null;
    }
}
/* eslint-disable no-underscore-dangle */
